// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"c7dfde16","429":"e039b196","441":"6e0a5a57","453":"7710904e","487":"f842d3c2","645":"a197632b","731":"859b46ed","819":"5b3fb2de","909":"f54d0a82","952":"71b3b753","996":"c35510f0"}[chunkId] + ".chunk.js";
};